
















import {Component, Vue, Prop} from 'vue-property-decorator'
import {InventoryItem} from '@/store/types'
import {Getter, Mutation, Action} from 'vuex-class'

@Component({})
export default class ListItemRound extends Vue {
  @Prop({type: Object, required: true}) public item!: InventoryItem
  @Prop({type: Number, required: true}) public index!: number
  @Prop({type: String, default: ''}) public iconClass!: string
}
